import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const CustomWarningDialog = ({ open, setOpen, message, extraContent, action, item, blockAction }) => {
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle id="alert-dialog-title">Warning!</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
        {extraContent}
      </DialogContent>
      <DialogActions>
        {blockAction ? (
          <Button onClick={handleClose} autoFocus>
            OK
          </Button>
        ) : (
          <>
            <Button onClick={handleClose}>No</Button>
            <Button
              onClick={() => {
                action(item);
                handleClose();
              }}
              autoFocus
            >
              Yes
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default CustomWarningDialog;
